import { useQuery } from 'react-query';
import { ReactQueryKeys } from 'services/api/reactQueryKeys';
import { getCompanySuppliers } from 'services/CompanyService';
import { SortByOption } from '../types';
import { SortDirection } from 'components/Table/types';
import { IRootReducerState } from 'store/store';
import { useSelector } from 'react-redux';

export const useGetCompanySuppliers = (
  page: number,
  perPage: number,
  searchBy: string,
  sortBy?: SortByOption,
  sortDirection?: SortDirection
) => {
  const activeCompanyId = useSelector(
    (state: IRootReducerState) => state.userInfo.company?.id
  );
  return useQuery({
    queryKey: [
      ReactQueryKeys.GET_COMPANY_SUPPLIERS,
      page,
      perPage,
      searchBy,
      sortBy,
      sortDirection,
      activeCompanyId,
    ],
    queryFn: () => {
      return getCompanySuppliers(
        page,
        perPage,
        searchBy,
        sortBy,
        sortDirection
      );
    },
  });
};
